export const TENDERLY_DEBUG_ENV_URL = 'https://dashboard.tenderly.co/venus-labs/debug';
